import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import CONSTANTS from "../utils/constants";
import { useTranslation } from "react-i18next";

export default function AdminSidebar({ isExpanded, handleToggle }) {
  const { t, i18n } = useTranslation();
  const [activeItem, setActiveItem] = useState();
  const [userPermissions, setUserPermissions] = useState([]);
  const [userName, setUserName] = useState("Admin"); // ✅ Kullanıcı ismi state'i
  const navigate = useNavigate();
  const location = useLocation();

  // Menü metinlerini t() fonksiyonu ile sarmaladık
  const menuItems = [
     { id: 1, icon: "bi-graph-up-arrow", text: t("analitika"), path: "/admin/home/analitica", page_id: 1 },
    { id: 2, icon: "bi-boxes", text: t("harytlar"), path: "/admin/home/products", page_id: 2 },
    { id: 3, icon: "bi-cart-check", text: t("sargytlar"), path: "/admin/home/orders", page_id: 6 },
    { id: 14, icon: "bi-check-circle", text: t("tamamlanan_sargytlar"), path: "/admin/home/orders/completed", page_id: 6 },
    { id: 15, icon: "bi-x-circle", text: t("ret_edilen_sargytlar"), path: "/admin/home/orders/rejected", page_id: 6 },
    { id: 5, icon: "bi-grid", text: t("bolumler"), path: "/admin/home/category", page_id: 11 },
    { id: 6, icon: "bi-images", text: t("banner"), path: "/admin/home/banner", page_id: 15 },
    { id: 8, icon: "bi-geo-alt", text: t("sargyt_yerleri"), path: "/admin/home/order-price", page_id: 23 },
    { id: 9, icon: "bi-clock", text: t("sargyt_wagty"), path: "/admin/home/order-times", page_id: 27 },
    { id: 10, icon: "bi-chat-left", text: t("message"), path: "/admin/home/notifications", page_id: 39 },
    { id: 11, icon: "bi-person-gear", text: t("ulanyjylar"), path: "/admin/home/users", page_id: 31 },
    { id: 13, icon: "bi-person-check", text: t("musderiler"), path: "/admin/home/customers", page_id: 36 },
    { id: 12, icon: "bi-gear ", text: t("sazlamalar"), path: "/admin/home/control", page_id: 35 },
  ];

  const filteredMenuItems = menuItems.filter((item) =>
    userPermissions.includes(item.page_id)
  );

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const userCookie = Cookies.get("user");
        if (!userCookie) {
          navigate("/admin");
          return;
        }
        
        const user = JSON.parse(userCookie);
        setUserName(user.username || user.name || "Admin"); // ✅ Cookie'den ismi al (field ismine göre güncelle: username/name)

        if (!user?.id) {
          navigate("/admin");
          return;
        }

        const response = await axios.get(`${CONSTANTS.baseRoute}/permissions`, {
          params: { user_id: user.id },
        });
        setUserPermissions(response.data.permissions);
      } catch (error) {
        console.error("Error fetching permissions:", error);
        navigate("/admin");
      }
    };

    fetchPermissions();
  }, [navigate]);

  useEffect(() => {
    // Pick the longest matching path — e.g. "/admin/home/orders/completed"
    // must win over the plain "/admin/home/orders" item, which would also
    // match via startsWith() since it's a prefix of the former.
    const currentItem = filteredMenuItems
      .filter((item) => location.pathname.startsWith(item.path))
      .sort((a, b) => b.path.length - a.path.length)[0];
    if (currentItem) {
      setActiveItem(currentItem.text);
    } else {
      setActiveItem(null);
    }
  }, [location.pathname, filteredMenuItems]);

  const handleItemClick = (item) => {
    setActiveItem(item.text);
    if (item.path) {
      navigate(item.path);
    }
  };

  const handleLogout = () => {
    Cookies.remove("user");
    navigate("/admin");
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div
      className={`admin-sidebar ${isExpanded ? "expanded" : "collapsed"} card rounded-0 d-flex flex-column p-2`}
      style={{ minHeight: "100vh" }}
    >
      <div className="d-inline-flex justify-content-between align-items-center gap-2 mb-1">
        {isExpanded && (
          <div
            className="d-flex align-items-center nav-link w-100 gap-3 bg-white border rounded px-2"
            style={{ cursor: "pointer", fontSize: "14px", height: "40px" }}
            onClick={() => navigate("/admin/home")}
          >
            <img src="/logo.png" style={{ width: "50px", objectFit: "contain" }} alt="" />
            <span style={{ color: location.pathname === "/admin/home" ? "var(--text-color)" : "#343a40", fontWeight: "bold" }}>
              Täze aý
            </span>
          </div>
        )}
        <button
          type="button"
          className="bg-white rounded border nav-link d-flex align-items-center justify-content-center"
          onClick={handleToggle}
          style={{ width: "40px", height: "40px" }}
        >
          <i className={`bi ${isExpanded ? "bi-x-lg" : "bi-list"}`}></i>
        </button>
      </div>

      <ul className="nav flex-column flex-grow-1 ">
        {filteredMenuItems.length > 0 ? (
          filteredMenuItems.map((item) => (
            <li className="nav-item mb-1 sidebar-item-wrap" key={item.id}>
              <a
                className="nav-link d-flex align-items-center sidebar-item"
                onClick={() => handleItemClick(item)}
                style={{
                  color: activeItem === item.text ? "var(--text-color)" : "#000000",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                <i className={`bi ${item.icon}`}></i>
                {isExpanded && <span className="ms-3">{item.text}</span>}
              </a>
            </li>
          ))
        ) : (
          isExpanded && <li className="text-center text-muted small">No permissions available</li>
        )}
      </ul>

      <div className="d-inline-flex justify-content-between align-items-center gap-2 mt-auto">
        {isExpanded && (
          <div className="d-flex align-items-center justify-content-between nav-link w-100 bg-white border rounded px-2" style={{ height: "40px" }}>
            <span style={{ color: "#343a40", fontSize: "12px", fontWeight: "600", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "80px" }}>
              {userName}
            </span>
            
            <div className="d-flex gap-1">
              <button 
                onClick={() => changeLanguage('tm')}
                className={`btn btn-sm p-0 px-1 ${i18n.language === 'tm' ? 'text-primary fw-bold' : 'text-muted'}`}
                style={{ fontSize: "10px" }}
              >
                TM
              </button>
              <div className="border-end"></div>
              <button 
                onClick={() => changeLanguage('ru')}
                className={`btn btn-sm p-0 px-1 ${i18n.language === 'ru' ? 'text-primary fw-bold' : 'text-muted'}`}
                style={{ fontSize: "10px" }}
              >
                RU
              </button>
            </div>
          </div>
        )}
        
        <button
          type="button"
          className="btn bg-white border nav-link d-flex align-items-center justify-content-center"
          onClick={handleLogout}
          title={t("cykys")}
          style={{ width: "40px", height: "40px" }}
        >
          <i className="bi bi-box-arrow-right text-danger"></i>
        </button>
      </div>
    </div>  
  );
}